export enum GymPermission {
  Reports = 'Reports',
  BookClasses = 'BookClasses',
  POS = 'POS',
  OrderCards = 'OrderCards',
}
